module.exports = __webpack_public_path__ + "IQ.png?793d68957879a169be75ccefab048c7d";